import React from 'react';
import { Route as ReactRout, RouteComponentProps } from 'react-router-dom';

import { Routes } from './routesConfig';

interface IProps {
    component?: React.ComponentType<RouteComponentProps<any>>;
    render?: (props: RouteComponentProps<any>) => React.ReactNode;
    exact?: boolean;
    path: Routes;
}

export const Route: React.FC<IProps> = ({ component: Component, render, ...rest }) => {
    return (
        <ReactRout
            {...rest}
            render={(props) => {
                if (render) {
                    return render(props);
                }
                if (Component) {
                    return <Component {...props} />;
                }
                return null;
            }}
        />
    );
};
